var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nutstore-share not-mobile" }, [
    _c(
      "a",
      { attrs: { href: "javascript:;" }, on: { click: _vm.toggleCode } },
      [
        _c("img", {
          ref: "share",
          staticClass: "share-img",
          attrs: { src: require("../../images/svg/float-share.svg"), alt: "" }
        })
      ]
    ),
    _vm._v(" "),
    _vm.visiable
      ? _c("div", { staticClass: "qr-code" }, [
          _c("p", { staticClass: "qr-title" }, [
            _vm._v(_vm._s(_vm.getConstants("EAGLE_LANDING_FLOAT_SHARE")))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "qr-subitle" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.getConstants("EAGLE_LANDING_FLOAT_SHARE_DESCRIPTION")
                ) +
                "\n\t\t"
            )
          ]),
          _vm._v(" "),
          _c("img", { staticClass: "qr-img", attrs: { src: _vm.url, alt: "" } })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }